import React from 'react';
import { useSelector } from 'react-redux';
import { useLocation } from 'react-router-dom';
import { TitleText, About } from './styled';
import { CATEGORIES } from '@app/src/config/categories';

interface Props {
  children: React.ReactNode;
}

export const Title: React.FC<Props> = ({ children }) => {
  const location = useLocation();
  const getAliasCategory = () => location.pathname.split('-')[2];
  const categoryConfig = CATEGORIES[getAliasCategory()];
  const operations = useSelector(state => state.typeOperation.data);

  return(
  <React.Fragment>
    <TitleText>{children}</TitleText>
    {
      operations && operations.length > 0 && <About bgColor={categoryConfig && categoryConfig.colorRgba}>Ingrese los datos de contacto en la descripción del aviso.</About>
    }
  </React.Fragment>
)};
